import React from "react";

const ToastNotification = ({ message }) => {
  return <div style={{ fontSize: "16px" }}>{message}</div>;
};
export default ToastNotification;
